import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { registerLicense } from '@syncfusion/ej2-base';
import * as Sentry from '@sentry/react';

////Error Boundry
import ErrorBoundary from 'routes/Pages/ErrorPage/ErrorBoundry';
import ErrorPage from 'routes/Pages/ErrorPage/ErrorPage';
import { invalidateLegacySessions } from 'routes/accessControl';

// microsoft graph api integrations

Sentry.init({
  dsn: "https://2fd6ddb5ba7cc2e56646ff70e3feee03@o4511891834863616.ingest.de.sentry.io/4511892589510736",
  environment: process.env.NODE_ENV,
  release: `myapp@${process.env.REACT_APP_VERSION || '1.0.0'}`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
});

invalidateLegacySessions();

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2VVhhQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkBiWX5ac3xXR2VZUEc=');

ReactDOM.render(
  <ErrorBoundary fallback={<ErrorPage />}>
    <App />
  </ErrorBoundary>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
